import { api } from "./client";

export const emptyClient = {
  name: "",
  businessName: "",
  phone: "",
  email: "",
  whatsapp: "",
  address: "",
  notes: "",
};

const pick = (data) =>
  Object.fromEntries(Object.keys(emptyClient).map((k) => [k, String(data[k] ?? "").trim()]));

export async function getClients() {
  const { clients } = await api.get("/clients", { auth: true });
  return clients;
}

export async function createClient(data) {
  const payload = pick(data);
  if (data.leadId) payload.leadId = data.leadId;
  const { id } = await api.post("/clients", payload, { auth: true });
  return id;
}

export async function updateClient(id, data) {
  await api.put(`/clients/${id}`, pick(data), { auth: true });
}

export async function deleteClient(id) {
  await api.del(`/clients/${id}`, { auth: true });
}

// Build a client record from a contact-form enquiry.
export function clientFromLead(lead) {
  return {
    ...emptyClient,
    name:         lead.name || "",
    businessName: lead.businessName || "",
    phone:        lead.phone || "",
    email:        lead.email || "",
    whatsapp:     lead.phone || "",
    notes:        [lead.service && `Enquired about: ${lead.service}`, lead.message]
      .filter(Boolean)
      .join("\n"),
    leadId: lead.id,
  };
}
